import { StoreType } from "../Settings/components/types";

const installationConfig = {
  storeTypeChoices: [
    {
      label: "Native Shopify storefront (theme-based)",
      value: StoreType.TRADITIONAL,
    },
    {
      label: "Custom / Headless storefront (uses Storefront API)",
      value: "CUSTOM",
    },
  ],

  storeTypeHelpText: `Theme stores are the traditonal stores that use Shopify's built-in Liquid templates. 
  Headless / Custom stores are custom applications built using the Storefront API, 
  which generally require a developer team to make it functional.`
};

export default installationConfig;